
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import React, { Component, Fragment } from 'react';

let eAngle = 1.5 * Math.PI;
let eAngleStart = 1.5 * Math.PI;
let frist = true
class Loadimg extends Component {
  componentDidMount () {
    this.drawArc()
  }
  drawArc =  () => {
    /**获取画布*/
    // let canvas = document.getElementById("myCanvas");
    let canvas = this.refs.myCanvas

    if (!canvas) return false
    /**
     * 动态设置画布的宽、高。注意 Canvas 的 width、height的值只能是纯数字，不能带单位
     * 如下所示，让画布填充父元素
     * @type {void|string|XML|*|jQuery}
     */
    canvas.width = 38;
    canvas.height = 38;

    /**获取画布上下文*/
    let ctx = canvas.getContext("2d");
    /**1)设置画笔颜色，不设置时默认为黑色
     * strokeStyle 属性设置或返回画笔的颜色、渐变或模式*/
    ctx.strokeStyle = "#fff";

    // 设置线宽和端点样式
    ctx.lineWidth = 4;
    ctx.lineCap = 'round';

    /**2）开始一条新路径
     * beginPath() 方法开始一条路径，或重置当前的路径*/
    ctx.beginPath();

    /**3）创建弧线/曲线
     * 圆心的位置为画布的中心，圆形半径为 50 像素(不能带单位)
     * 起始角度为 0，即 x 轴的正方向，结束角度为 360度*/
    // ctx.arc(canvas.width / 2, canvas.height / 2, 15, .5 * Math.PI, 1.5 * Math.PI, false);
    ctx.arc(canvas.width / 2, canvas.height / 2, 15, eAngleStart, eAngle, true);

    /**4）绘制定义好的路径
     * stroke() 方法实际地绘制路径*/
    ctx.stroke();

    if (frist) {
      eAngle = eAngle - 0.1;
      if (eAngle < .5 * Math.PI) {
        eAngle = .5 * Math.PI;
        frist = false
      }
    } else {
      eAngle = eAngle - 0.1;
      eAngleStart = eAngleStart - 0.1;
      if (eAngle <= 0) {
        eAngle = 2 * Math.PI;
      }
      if (eAngleStart <= 0) {
        eAngleStart = 2 * Math.PI;
      }
    }

    requestAnimationFrame(() => {
      this.drawArc();
    });
  }
  componentWillUnmount () {
    eAngle = 1.5 * Math.PI;
    eAngleStart = 1.5 * Math.PI;
    frist = true
  }
  render() {
    return (
      <Fragment>
        <canvas ref='myCanvas'>
          浏览器不支持 Canvas
        </canvas>
      </Fragment>
    )
  }
}

export default Loadimg;